export enum RoleErrorCode {
    'DuplicateRoleNameError' = 'DuplicateRoleNameError',
}
